import classnames from 'classnames';
import React from 'react';
import styles from './SelectIcon.module.scss';
export const SelectIcon = ({ error, focused, selected, disabled }) => (<span className={classnames(styles.icon, {
        [styles.selected]: selected,
        [styles.focused]: focused,
        [styles.disabled]: disabled,
        [styles.error]: error,
    })}/>);
